function Dd7UploadCtrl(toaster, $scope, $state, $stateParams, $rootScope, Dd7Service, Upload) {
  'ngInject';

  const vm = this;
  vm.orgId = $stateParams.orgId;
  console.log('DD7Upload init - $stateParams.orgId:', $stateParams.orgId, '$rootScope.currentOrg:', $rootScope.currentOrg);
  vm.uploading = false;
  vm.file = null;
  vm.accrualMonth = null;
  vm.preview = null;

  vm.init = function() {
    // Set default month to previous month
    var now = new Date();
    var prevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    vm.accrualMonth = prevMonth.toISOString().slice(0, 7); // YYYY-MM format
  };

  vm.upload = function() {
    if (!vm.file) {
      toaster.pop('warning', 'Warning', 'Please select a file');
      return;
    }
    if (!vm.accrualMonth) {
      toaster.pop('warning', 'Warning', 'Please select an accrual month');
      return;
    }

    vm.uploading = true;
    // Fixed: service method is 'upload', not 'uploadFile'
    Dd7Service.upload($stateParams.orgId, vm.file, function(response) {
      vm.uploading = false;
      if (response.status == 200) {
        toaster.pop('success', 'Success', 'File uploaded and processed');
        vm.preview = response.data;
      } else {
        toaster.pop('error', 'Error', response.data.error || 'Upload failed');
      }
    });
  };

  vm.goBack = function() {
    var currentOrgId = $stateParams.orgId || $state.params.orgId;
    console.log('DD7Upload goBack - orgId:', currentOrgId, 'vm.orgId:', vm.orgId);
    $state.go('user.organization.dashboard.dd7.list', { orgId: currentOrgId }, { inherit: false });
  };

  vm.goToDashboard = function() {
    var currentOrgId = $stateParams.orgId || $state.params.orgId;
    $state.go('user.organization.dashboard.dd7.list', { orgId: currentOrgId }, { inherit: false });
  };

  // Initialize on load
  vm.init();
}

Dd7UploadCtrl.$inject = ['toaster', '$scope', '$state', '$stateParams', '$rootScope', 'Dd7Service', 'Upload'];

export default {
  name: 'Dd7UploadCtrl',
  fn: Dd7UploadCtrl
};
